import { render, staticRenderFns } from "./FeatureRequestCommentsModal.vue?vue&type=template&id=4784021a&scoped=true"
import script from "./FeatureRequestCommentsModal.vue?vue&type=script&lang=js"
export * from "./FeatureRequestCommentsModal.vue?vue&type=script&lang=js"
import style0 from "./FeatureRequestCommentsModal.vue?vue&type=style&index=0&id=4784021a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4784021a",
  null
  
)

export default component.exports